// extracted by css-extract-rspack-plugin
export default {"cls1":"step_two-cls1_zPp","cls2":"step_two-cls2_zlN step_two-cls1_zPp"};